export default "/_next/static/images/b157687f21af2a48bc3edd0319239a67.jpg";